export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9389.51cc7272.jpg";